import { useEffect, useState } from 'react';
import { fetchActiveDiscounts, type Discount } from '@/services/discounts';

// Promociones vigentes para la tienda pública. Se comparte entre el home, el
// catálogo, el detalle de producto y el checkout para aplicar el descuento.
export function useActiveDiscounts() {
  const [discounts, setDiscounts] = useState<Discount[]>([]);

  useEffect(() => {
    let cancelled = false;
    fetchActiveDiscounts().then((d) => {
      if (!cancelled) setDiscounts(d);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return discounts;
}